<template>
    <div>
        <div class="component-settings-overview" v-if="budgetsPredictionsLoaded && contractsLoaded">

            <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
                <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
            </div>
            <div class="el-card__header text-left border" slot="header" v-else>
                <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
            </div>

            <el-card class="box-card" id="main-header" shadow="never"
                     style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                     body-style="background-color: #f4f7fa; padding: 0px;"
            >
                <div class="row">
                    <div class="col-12 mt-50 text-left">
                        <h4>Data usage</h4>
                    </div>
                    <div class="col-xl-6 col-12 mt-20">
                        <el-card class="box-card text-left" shadow="never">
                            <div slot="header">
                                <p class="title">Predictions made</p>
                            </div>
                            <p>This month: {{predictions['month'].toLocaleString('nl-NL')}}</p>
                            <p>Total: {{predictions['total'].toLocaleString('nl-NL')}}</p>
                        </el-card>
                    </div>
                    <div class="col-xl-6 col-12 mt-20">
                        <el-card class="box-card text-left" shadow="never">
                            <div slot="header">
                                <p class="title">Hours budgeted</p>
                            </div>
                            <p>This month: {{budgets['month'].toLocaleString('nl-NL')}}</p>
                            <p>Total: {{budgets['total'].toLocaleString('nl-NL')}}</p>
                        </el-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-20">
                        <el-card class="box-card" shadow="never">
                            <div slot="header text-left">
                                <p class="title">Monthly tracked contracts</p>
                            </div>
                            <el-table
                                :data="contracts"
                                style="width: 100%">
                                <el-table-column
                                    v-for="col in contractsPeriods"
                                    :key="col"
                                    :prop="col"
                                    :label="col">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-50 text-left">
                        <h4>Billing & Payment</h4>
                    </div>
                    <div class="col-xl-4 col-12 mt-20">
                        <el-card class="box-card text-left" shadow="never">
                            <div slot="header">
                                <p class="title">Tier 1</p>
                            </div>
                            <div class="row center-align-vert">
                                <div class="col-6">
                                    <p>Subscription</p>
                                    <p>€975/month</p>
                                    <p>500 contracts</p>
                                    <p class="mt-10">Contracts {{Math.min(currentNumberOfContracts,500)}}/500</p>
                                </div>
                                <div class="col-6 text-right">
                                    <el-progress  :width=100 type="circle" :percentage="getPercentage(1)"></el-progress>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <div class="col-xl-4 col-12 mt-20">
                        <el-card class="box-card text-left" shadow="never">
                            <div slot="header">
                                <p class="title">Tier 2</p>
                            </div>
                            <div class="row center-align-vert">
                                <div class="col-6">
                                    <p>Usage based</p>
                                    <p>€2/user</p>
                                    <p>500-1000 contracts</p>
                                    <p class="mt-10">Contracts {{Math.min(Math.max(currentNumberOfContracts-500,0),500)}}/500</p>
                                </div>
                                <div class="col-6 text-right">
                                    <el-progress :width=100 type="circle" :percentage="getPercentage(2)"></el-progress>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <div class="col-xl-4 col-12 mt-20">
                        <el-card class="box-card text-left" shadow="never">
                            <div slot="header">
                                <p class="title">Tier 3</p>
                            </div>
                            <div class="row center-align-vert">
                                <div class="col-6">
                                    <p>Usage based</p>
                                    <p>€1.75/user</p>
                                    <p>1000-2000 contracts</p>
                                    <p class="mt-10">Contracts {{Math.min(Math.max(currentNumberOfContracts-1000,0),1000)}}/1000</p>
                                </div>
                                <div class="col-6 text-right">
                                    <el-progress :width=100 type="circle" :percentage="getPercentage(3)"></el-progress>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-12">
                        <div class="el-card__header text-left border" slot="header">
                            <p class="title">Monthly costs: €{{975 + 2 * Math.max(currentNumberOfContracts-500,0) + 1.75 * Math.max(currentNumberOfContracts-1000,0)}}</p>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
        <el-card class="box-card" shadow="never" v-else  style="min-height: 300px;" v-loading="(!budgetsPredictionsLoaded || !contractsLoaded)">
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getHeadersWithAccessToken, getWeekNumber } from '../../functions.js'
export default {
    data () {
        return {
            predictions: {},
            budgets: {},
            contractsPeriods: [],
            contracts: [],
            budgetsPredictionsLoaded: false,
            contractsLoaded: false,
            currentNumberOfContracts: 0
        }
    },
    components: {
    },
    methods: {
        getPercentage (tier) {
            if (tier === 1) {
                return Math.round(Math.min((this.currentNumberOfContracts / 500) * 100, 100))
            } else if (tier === 2) {
                return Math.round(Math.max(Math.min(((this.currentNumberOfContracts - 500) / 500) * 100, 100), 0))
            } else if (tier === 3) {
                return Math.round(Math.max(Math.min(((this.currentNumberOfContracts - 1000) / 1000) * 100, 100), 0))
            }
        }
    },
    created () {
        axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/settings/overview/budgets_predictions', { 'format': 'aod', 'year': getWeekNumber(new Date())[0], 'week': getWeekNumber(new Date())[1] }, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.budgets['month'] = response.data.data[0]['hours_budgeted_l4w']
                this.budgets['total'] = response.data.data[0]['hours_budgeted']
                this.predictions['month'] = response.data.data[0]['predictions_made_l4w']
                this.predictions['total'] = response.data.data[0]['predictions_made']
                this.budgetsPredictionsLoaded = true
            })
            .catch(error => {
                console.log(error)
            })
        axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/settings/overview/active_contracts', { 'format': 'aod' }, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                let obj = {}
                for (let item of response.data.data) {
                    this.contractsPeriods.push(item['x_label'])
                    obj[item['x_label']] = item['average_contracts']
                }
                this.contracts.push(obj) // Needs to be a list for el-table
                this.contractsLoaded = true
                this.currentNumberOfContracts = this.contracts[0][this.contractsPeriods[this.contractsPeriods.length - 1]]
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-overview {
    p {
        margin-bottom: 0px;
    }
    .title {
        font-weight: 800;
    }
    .el-progress-circle {
        widht: 100px;
        height: 100px;
    }
    .border {
        border: 1px solid #EBEEF5
    }
}
</style>
